module.exports = __webpack_public_path__ + "img/banner-3.81e0b416.jpg";